module.exports = __webpack_public_path__ + "img/sectionCover3.3c621426.png";